module.exports = __webpack_public_path__ + "img/joy.8a08b460.jpg";